import React, { useState } from 'react';
import { Animal } from '../data/zooData';

interface AnimalCardProps {
  animal: Animal;
}

const AnimalCard: React.FC<AnimalCardProps> = ({ animal }) => {
  const [isHovered, setIsHovered] = useState(false);
  
  return (
    <div 
      className="relative overflow-hidden rounded-lg shadow-lg group transition-all duration-300 transform hover:scale-105"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div 
        className="relative h-64 overflow-hidden"
        style={{ 
          backgroundImage: `url(${animal.image})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        {/* Overlay sombre au survol */}
        <div 
          className={`
            absolute inset-0 bg-black transition-opacity duration-300 
            ${isHovered ? 'opacity-60' : 'opacity-30'}
          `}
        ></div>
        
        <div 
          className={`
            absolute inset-0 flex flex-col justify-between p-6
            text-white transition-all duration-300
          `}
        >
          {/* Badge espèce */}
          <div className="bg-yellow-600 text-xs font-semibold px-3 py-1 rounded-full self-start">
            {animal.espece}
          </div>
          
          <div>
            <h3 className="text-2xl font-bold mb-1">{animal.nom}</h3>
            <div 
              className={`
                overflow-hidden transition-all duration-300
                ${isHovered ? 'max-h-32 opacity-100' : 'max-h-0 opacity-0'}
              `}
            >
              <p className="text-sm">{animal.description}</p>
            </div>
          </div>
        </div>
      </div>
      
      {/* Indicateur visuel interactif */}
      <div 
        className={`
          absolute bottom-4 right-4 w-8 h-8 flex items-center justify-center
          rounded-full bg-green-600 text-white transform transition-all duration-300
          ${isHovered ? 'rotate-180 scale-110' : ''}
        `}
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </div>
    </div>
  );
};

export default AnimalCard;
